import React from 'react';
import './Footer.css'

const Footer = () => (
  <div className='footer'>
    <div className='footer-main'>
      <p>Copyright © 2023 Mishab_Vibes All rights reserved</p>
    </div>
  </div>
);

export default Footer;
